export enum BillingsTaxiTaxiContributionPenaltyType {
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
}

export type BillingsTaxiTaxiContributionPenaltyDummy = {
  type: null;
  comment: string;
  amount: number | null;
};

export type BillingsTaxiTaxiContributionPenaltyReal = {
  type: BillingsTaxiTaxiContributionPenaltyType;
  comment: string;
  amount: number | null;
};

type BillingsTaxiTaxiContributionPenalty =
  | BillingsTaxiTaxiContributionPenaltyDummy
  | BillingsTaxiTaxiContributionPenaltyReal;

export default BillingsTaxiTaxiContributionPenalty;
